module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_info-o-d1771efd6bf2a56aa2da7865e184ad41.svg";